import React from 'react';
import styled from 'styled-components';
import { Heading, NotationBlock, Text, WYSIWYG } from '../../util/typography';
import TextBlock from '../TextBlock';
import ComponentWrapper from '../layout/ComponentWrapper';
import * as colors from '../../util/colors';
import { createMarkup } from '../../util/functions';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';
import NCCNcallout from '../NCCNcallout';

const bp= NAVIGATION_BREAKPOINT;

const StyledComponentWrapper = styled(ComponentWrapper)`
    border-bottom: 1px solid ${colors.pebble};
    max-width: 824px;

    &:last-child{ 
      [class*=ComponentWrapper]{
         margin-bottom: 12px;
         }
    }

    [class*=ComponentWrapper]{
    margin-top: 0;
    }

    p{
      margin: 10px auto;
    }

    &:last-child {
        border-bottom: none;
    }

    [class*='NotationBlock__TitleContainer']{
        padding-bottom: 8px;
    }
    @media(max-width: ${bp}){
     &:last-child {
        padding-bottom: 0px;
        }
    }
`;


const CustomHomePageNccnAccordion = props => {
    return (
        <StyledComponentWrapper>
                <NCCNcallout
                    data={props.body}
                    references={props.references}
                    definitions={props.definitions}
                    footnotes={props.footnotes}
                    title={props.title}
                />
        </StyledComponentWrapper>
    )

}

export default CustomHomePageNccnAccordion;